import React from "react";
import PropTypes from "prop-types";
import { cropNumber } from "../../../../../common/helpers/helpers";

const Summary = ({ data }) => {
  if (!data) return null;
  return (
    <React.Fragment>
      {data.total_samples && (
        <React.Fragment>
          <h5> Summary of results </h5>
          <h6>
            <b>{"Total samples: "}</b>
            {data.total_samples
              ? data.total_samples.toLocaleString().replace(",", " ")
              : ""}
          </h6>
        </React.Fragment>
      )}
      {data.hotspot != null && (
        <h6>
          <b>{"Hotspot: "}</b>
          {data.hotspot ? "true" : "false"}
        </h6>
      )}
      {data.effect && (
        <h6>
          <b>{"Effect: "}</b>
          {data.effect}
        </h6>
      )}
      {data.structural_motif && (
        <h6>
          <b>{"Structural motif: "}</b>
          {data.structural_motif}
        </h6>
      )}
      {data.mut_rate && (
        <h6>
          <b>{"Mut rate: "}</b>
          {cropNumber(data.mut_rate)}
        </h6>
      )}
    </React.Fragment>
  );
};

Summary.propTypes = {
  data: PropTypes.shape({
    structural_motif: PropTypes.string,
    mut_rate: PropTypes.number,
    effect: PropTypes.string,
    hotspot: PropTypes.bool,
    total_samples: PropTypes.number,
  }),
};

Summary.defaultProps = {
  data: null,
};
export default Summary;
